import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { BaseBus } from "./BaseBus";
export class BidComponentBus extends BaseBus{

    constructor(busObj: BidComponentBus) {
        super(busObj);

    }
    CID(): any {
        return this.bidComponentID;
    }
    setId(id: any) {
        this.bidComponentID = id;
    }
    setParentId(id: any) {
        this.bidSheetDetailId = id;
    }
    initialize(data: BidComponentBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: BidComponentBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }

    bidComponentID :string;
    bidSheetDetailId : string;
    catogory  : string;
    qty : number;
    remark:string;
    //compInsertDt:Date;
    categoryDesc:Date;
    categoryTypeDesc:string;
    categoryName:string;
    categoryTypeName:string
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
    categoryTypeId:string;
    sortOrder  : number;
    public dragging: boolean
    isFrmTemplate : boolean;

    material:string;
    pipeFitter:number;
    caseSetter:number;
    labor:number;

    perMaterial:string;
    perPipeFitter:number;
    perCaseSetter:number;
    perLabor:number;
    tempLaborTotal: number;
}